module.exports = __webpack_public_path__ + "img/menu_bottom_13.f200533a.svg";